// NOTE: never read AWS credentials here. Anything named REACT_APP_* is compiled
// into the public JS bundle, so keys placed here are readable by any visitor.
// S3 access belongs on the backend (env vars locally, the EC2 IAM role in AWS).
const config = {
  region: process.env.REACT_APP_AWS_REGION,
  queueUrl: process.env.REACT_APP_SQS_QUEUE_URL,
  serverPort: parseInt(process.env.REACT_APP_SERVER_PORT || "4025", 10),
  serverUrl: process.env.REACT_APP_SERVER_URL,
  DBType: process.env.REACT_APP_DB_TYPE,
  DBuser: process.env.REACT_APP_DB_USER,
  DBhost: process.env.REACT_APP_DB_HOST,
  database: process.env.REACT_APP_DB_DATABASE,
  DBpassword: process.env.REACT_APP_DB_PASSWORD,
  DBport: parseInt(process.env.REACT_APP_DB_PORT || "3306", 10),
  tableName: process.env.REACT_APP_TABLE_NAME,
  mongoDB: {
    url: process.env.REACT_APP_MONGO_URL,
    dburl: process.env.REACT_APP_MONGO_DBURL,
    database: process.env.REACT_APP_MONGO_DATABASE
  }
};

export default config;
